import { BaseDataModel } from "@domain/CRM/BaseDataModel";

export class LabTest extends BaseDataModel {
	name: string = "";
	labName: string = "";
	/** The Labs record this test belongs to (Airtable "Lab", a single-record link). A deal names its lab
	 *  only through its Lab Package — these tests — so this is how a job reaches its lab record. */
	labId?: string;
	/** That Labs record's Airtable link. */
	labUrl?: string;
}
